export default __webpack_public_path__ + "static/media/map2.c717fe42.jpg";